import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import {useSelector} from "react-redux";
import {selectAdminUser} from "../../app/adminUser/selectors";

export function AuthValidate() {
    const {isAuthenticated} = useSelector(selectAdminUser)

    try {
        if (!isAuthenticated) {
            return <Navigate to={{ pathname: '/login' }} />;
        }
    } catch {
        return <Navigate to={{ pathname: '/login' }} />;
    }

    return <Outlet />;
}
